import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { ExportServiceServiceProxy, ExportRequestDto } from '@shared/service-proxies/service-proxies';
import { saveAs } from 'file-saver';

@Injectable()
export class ExportService {

  constructor(
    private exportService: ExportServiceServiceProxy,
    private loadingCtrl: LoadingController
  ) { }

  async export(request: ExportRequestDto, loading: HTMLIonLoadingElement) {
    this.exportService.export(request).subscribe(async fileResponse => {
      this.saveFile(fileResponse, request.entity);
      if (loading) await loading.dismiss();
    });
  }

  saveFile(fileResponse, entity) {
    const d = new Date();
    var data = new Blob([fileResponse.data], {type:'base64'});
    saveAs(data, `${entity}_${d.getMonth()+1}_${d.getDate()}_${d.getFullYear()}.xlsx`);
  }

}
